import { create } from "zustand";

/**
 * AssistantWidget 모달 open state 외부 제어 store (사용자 결정 2026-05-08).
 * floating button 제거 후 AiToolsSection 의 AI 비서 카드 클릭에서 open 트리거.
 *
 * 2026-05-09 — 빠른 질문 칩 (3순위) 추가:
 *   openWithMessage(msg) — 모달 오픈 + 메시지 자동 전송 prefill
 *   consumePrefill() — AssistantWidget 가 mount 후 1회 소비 (자동 send)
 */
interface ChatState {
  open: boolean;
  prefillMessage: string | null;
  setOpen: (v: boolean) => void;
  openWithMessage: (msg: string) => void;
  consumePrefill: () => string | null;
}

export const useChatStore = create<ChatState>((set, get) => ({
  open: false,
  prefillMessage: null,
  setOpen: (v) => set({ open: v }),
  openWithMessage: (msg) => set({ open: true, prefillMessage: msg }),
  consumePrefill: () => {
    const msg = get().prefillMessage;
    if (msg) set({ prefillMessage: null });
    return msg;
  },
}));
